import { Trans } from "react-i18next";import { cn } from "../../../lib/utils";
import { SCHEDULE_MODES } from "../constants/scheduleConfig";

/**
 * ScheduleModeToggle
 *
 * Switches a day between "All Weeks" (single day_type applies to every
 * occurrence of that weekday) and "Custom" (a distinct day_type per
 * week_number 1-5).
 *
 * Props:
 * - mode: "All" | "Custom"
 * - onChange: (nextMode: "All" | "Custom") => void
 * - disabled: boolean (optional)
 */
export function ScheduleModeToggle({ mode, onChange, disabled = false }) {
  return (
    <div className="inline-flex rounded-xl border border-(--color-text-border) p-0.5 w-fit bg-white">
      <button
        type="button"
        disabled={disabled}
        onClick={() => onChange(SCHEDULE_MODES.ALL)}
        className={cn(
          "h-8 px-4 rounded-[10px] text-xs font-semibold transition disabled:opacity-50 disabled:cursor-not-allowed",
          mode === SCHEDULE_MODES.ALL ?
          "bg-primary text-white" :
          "per-file-hint hover:text-foreground"
        )}>
        <Trans i18nKey="dateTime.allWeeks2" />
      
      </button>
      <button
        type="button"
        disabled={disabled}
        onClick={() => onChange(SCHEDULE_MODES.CUSTOM)}
        className={cn(
          "h-8 px-4 rounded-[10px] text-xs font-semibold transition disabled:opacity-50 disabled:cursor-not-allowed",
          mode === SCHEDULE_MODES.CUSTOM ?
          "bg-primary text-white" :
          "per-file-hint hover:text-foreground"
        )}>
        <Trans i18nKey="weeklySchedule.custom" />
      
      </button>
    </div>);

}
